import type { VideoObjectData } from "~www/types/video-object";

import { generateVideoObjectSchema } from "~www/lib/videos/generate-video-object-schema";

type VideoSchemaProps = {
  schemaId: string;
  videoData: VideoObjectData;
};

/**
 * Renders JSON-LD `VideoObject` markup from CMS-owned metadata.
 */
function VideoSchema({ schemaId, videoData }: VideoSchemaProps) {
  const videoSchema = generateVideoObjectSchema(videoData);

  return (
    <script id={`video-schema-${schemaId}`} type="application/ld+json">
      {JSON.stringify(videoSchema)}
    </script>
  );
}

export { VideoSchema };
